import React from 'react';
import { View, StyleSheet } from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';

interface RadioButtonProps {
  isSelected: boolean;
  size?: 'small' | 'medium';
}

/**
 * Standalone radio button indicator component
 * Used in SoldFeedbackModal and ReportModal for option selection
 */
export const RadioButton: React.FC<RadioButtonProps> = ({
  isSelected,
  size = 'medium',
}) => {
  const containerSize = size === 'small' ? 14 : 16;
  const innerSize = size === 'small' ? 6 : 8;

  return (
    <View
      style={[
        styles.outer,
        {
          width: containerSize,
          height: containerSize,
          borderRadius: containerSize / 2,
        },
        isSelected && styles.outerSelected,
      ]}
    >
      {isSelected && (
        <View
          style={[
            styles.inner,
            {
              width: innerSize,
              height: innerSize,
              borderRadius: innerSize / 2,
            },
          ]}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  outer: {
    borderWidth: 1,
    borderColor: MARKETPLACE_COLORS.checkboxBorder,
    backgroundColor: MARKETPLACE_COLORS.checkboxBackground,
    alignItems: 'center',
    justifyContent: 'center',
  },
  outerSelected: {
    backgroundColor: MARKETPLACE_COLORS.radioSelected,
    borderColor: MARKETPLACE_COLORS.radioSelected,
  },
  inner: {
    backgroundColor: MARKETPLACE_COLORS.radioInner,
  },
});
